<script>
export default {
  data() {
    return {
      tabs: [],
      activeTabIndex: parseInt(this.$route.query.activeTabIndex) || 0
    };
  },

  methods: {
    addTab(item) {
      const index = this.$slots.default.indexOf(item.$vnode);
      this.tabs.splice(index, 0, item);
    },

    content() {
      return this.tabs[0].$slots.content;
    },

    navigateToTab(index) {
      this.changeTab(this.activeTabIndex, index);
    },

    changeTab(oldIndex, newIndex) {
      let oldTab = this.tabs[oldIndex] || {};
      let newTab = this.tabs[newIndex];
      this.activeTabIndex = newIndex;
      oldTab.active = false;
      newTab.active = true;

      // Remove because back button is not working
      //this.$router.push({query: Object.assign({}, this.$route.query, {activeTabIndex: newIndex})});
    },

    renderTabs(createElement) {
      return this.tabs.map((tab, index) => {
        if (!tab) return;

        return createElement(
          "div",
          {
            class: [
              { "bg-gray-800 hasArrow": this.activeTabIndex === index },
              "py-5 px-8 border-r border-gray-800 text-white cursor-pointer"
            ],
            on: { click: () => this.navigateToTab(index) }
          },
          [
            createElement(
              "div",
              { class: "uppercase whitespace-no-wrap" },
              tab.title
            ),
            createElement(
              "div",
              { class: "text-2xl mt-2 whitespace-no-wrap" },
              tab.subtitle
            )
          ]
        );
      });
    }
  },

  render: function(createElement) {
    return createElement("div", {}, [
      createElement(
        "div",
        { class: "flex bg-gray-700 overflow-auto" },
        this.renderTabs(createElement)
      ),
      createElement("div", {}, this.$slots.default)
    ]);
  },

  watch: {
    tabs(newList) {
      if (newList.length > 0) {
        this.navigateToTab(this.activeTabIndex);
      }
    }
  }
};
</script>

<style scoped>
.hasArrow {
  position: relative;
}

.hasArrow:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -8px;
  margin-top: -8px;
  width: 0;
  height: 0;
  border-bottom: solid 8px white;
  border-left: solid 8px transparent;
  border-right: solid 8px transparent;
}
</style>
